import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../common/components/base.component';

@Component({
    template: `
        <ig-page-spinner [loadingTip]="'Redirecting to Google Map...'"></ig-page-spinner>
    `
})
export class GpsRedirectComponent extends BaseComponent {

    constructor(private activatedRoute: ActivatedRoute) {
        super({activatedRoute});

        navigator.geolocation.getCurrentPosition((position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            console.log(`lat: ${lat}, lng: ${lng}`);

            //let googleMapUrl = localStorage.getItem('gps-url');
            let {locationString} = this.allRouteParams;
            let googleMapUrl = locationString;
            // googleMapUrl = googleMapUrl.replace(/(\|)+/g, "/");
            googleMapUrl = 'http://www.google.com/maps/dir/?api=1&' + googleMapUrl.replace('${GPS}', `${lat},${lng}`);
            window.location.href = googleMapUrl;
        }, (error) => {
            console.log('ERROR(' + error.code + '): ' + error.message);
            alert('Unable to retrieve your location!' + 'ERROR(' + error.code + '): ' + error.message);
        });
    }

}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/gps.redirect.component.ts